import { useEffect, useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';

export default function KurumsalPage() {
  const [counters, setCounters] = useState({
    years: 0,
    professionals: 0,
    customers: 0,
    workers: 0
  });

  useEffect(() => {
    // SEO Meta Tags
    document.title = 'Kurumsal | Adana OSGB Mersin Hatay Osmaniye İş Sağlığı Güvenliği | ASSA';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'ASSA OSGB kurumsal bilgileri. Adana, Mersin, Hatay, Osmaniye bölgelerinde 14 yıllık deneyimle iş sağlığı ve güvenliği hizmetleri. İş güvenliği uzmanı, işyeri hekimi, OSGB danışmanlığı. 630+ mutlu müşteri, 32.500+ korunan çalışan.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'ASSA OSGB kurumsal, Adana OSGB şirket, Mersin OSGB hakkında, Hatay OSGB kurumsal, Osmaniye OSGB, iş sağlığı ve güvenliği şirketi, OSGB firması');
    }

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://www.assaosgb.com.tr/kurumsal');
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "Kurumsal | ASSA OSGB",
      "description": "Adana, Mersin, Hatay, Osmaniye bölgelerinde iş sağlığı ve güvenliği hizmetleri sunan ASSA OSGB kurumsal bilgileri",
      "url": "https://www.assaosgb.com.tr/kurumsal",
      "mainEntity": {
        "@type": "Organization",
        "name": "ASSA OSGB",
        "foundingDate": "2010",
        "description": "Adana, Mersin, Hatay, Osmaniye bölgelerinde iş sağlığı ve güvenliği alanında 14 yıllık deneyim. İş güvenliği uzmanı, işyeri hekimi ve OSGB hizmetleri.",
        "numberOfEmployees": "131+",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Reşatbey Mahallesi, 62015 Sokak No:4, ASSA Plaza",
          "addressLocality": "Seyhan",
          "addressRegion": "Adana",
          "postalCode": "01120",
          "addressCountry": "TR"
        },
        "areaServed": [
          {"@type": "City", "name": "Adana"},
          {"@type": "City", "name": "Mersin"},
          {"@type": "City", "name": "Hatay"},
          {"@type": "City", "name": "Osmaniye"}
        ]
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  // Counter Animation
  useEffect(() => {
    const targets = {
      years: 14,
      professionals: 131,
      customers: 630,
      workers: 32500
    };

    const duration = 2000; // 2 seconds
    const steps = 60;
    const interval = duration / steps;

    const incrementValues = {
      years: targets.years / steps,
      professionals: targets.professionals / steps,
      customers: targets.customers / steps,
      workers: targets.workers / steps
    };

    let currentStep = 0;

    const timer = setInterval(() => {
      currentStep++;
      
      if (currentStep <= steps) {
        setCounters({
          years: Math.min(Math.round(incrementValues.years * currentStep), targets.years),
          professionals: Math.min(Math.round(incrementValues.professionals * currentStep), targets.professionals),
          customers: Math.min(Math.round(incrementValues.customers * currentStep), targets.customers),
          workers: Math.min(Math.round(incrementValues.workers * currentStep), targets.workers)
        });
      } else {
        clearInterval(timer);
        setCounters(targets);
      }
    }, interval);

    return () => clearInterval(timer);
  }, []);

  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Güvenlik',
      description: 'Çalışan güvenliğini her şeyin üstünde tutuyoruz'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Sağlık',
      description: 'Çalışanların sağlığını korumak önceliğimizdir'
    },
    {
      icon: 'ri-award-line',
      title: 'Kalite',
      description: 'En yüksek kalite standartlarında hizmet veriyoruz'
    },
    {
      icon: 'ri-team-line',
      title: 'Profesyonellik',
      description: 'Uzman kadromuzla profesyonel çözümler sunuyoruz'
    }
  ];

  const certifications = [
    {
      icon: 'ri-file-shield-2-line',
      title: 'ISO 9001',
      description: 'Kalite Yönetim Sistemi Sertifikası'
    },
    {
      icon: 'ri-government-line',
      title: 'Bakanlık Onayı',
      description: 'Çalışma ve Sosyal Güvenlik Bakanlığı Yetki Belgesi'
    },
    {
      icon: 'ri-hospital-line',
      title: 'Sağlık Bakanlığı',
      description: 'Sağlık Bakanlığı Onaylı Laboratuvar'
    },
    {
      icon: 'ri-medal-line',
      title: 'Akreditasyon',
      description: 'TÜRKAK Akreditasyon Belgesi'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-orange-600 to-orange-700 text-white py-20 mt-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Kurumsal</h1>
          <p className="text-xl text-orange-100 max-w-3xl mx-auto">
            İş sağlığı ve güvenliği alanında 14 yıllık deneyimimizle güvenilir çözüm ortağınızız
          </p>
        </div>
      </section>

      {/* About Content */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Hakkımızda</h2>
              <p className="text-gray-600 leading-relaxed mb-6 text-justify">
                ASSA İş Sağlığı ve Güvenliği LTD. ŞTİ. 2010 yılında kurulmuş olup, Türkiye'de iş sağlığı ve güvenliği kültürünü oluşturmak adına faaliyet göstermektedir. Şirketimiz, bine yakın işletmeye ve on binlerce çalışana hizmet vererek sektörde öncü konumundadır.
              </p>
              <p className="text-gray-600 leading-relaxed text-justify">
                Yenilikçi ve profesyonel bakış açımızla, kuruluşların sağlık ve güvenlik risklerini tutarlı bir şekilde belirlemelerine ve kontrol etmelerine yardımcı oluyoruz. Amacımız, olay potansiyelini azaltmak, mevzuata uyumu sağlamak ve performansı sürekli iyileştirmektir.
              </p>
            </div>
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/d872d034ce4a0dc6a8853d28a3ca6865.jpg" 
                alt="ASSA OSGB Ofis" 
                className="w-full rounded-lg shadow-lg"
              />
            </div>
          </div>

          {/* Mission & Vision */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
            <div className="bg-orange-50 p-8 rounded-lg">
              <div className="flex items-center mb-4">
                <i className="ri-eye-line text-3xl text-orange-600 mr-4"></i>
                <h3 className="text-2xl font-bold text-gray-800">Vizyonumuz</h3>
              </div>
              <p className="text-gray-600 leading-relaxed text-justify">
                Türkiye'de iş sağlığı ve güvenliği alanında lider konumda olmak, çalışanların güvenli ve sağlıklı ortamlarda çalışmalarını sağlayarak sıfır iş kazası hedefine ulaşmaktır.
              </p>
            </div>
            <div className="bg-red-50 p-8 rounded-lg">
              <div className="flex items-center mb-4">
                <i className="ri-target-line text-3xl text-red-600 mr-4"></i>
                <h3 className="text-2xl font-bold text-gray-800">Misyonumuz</h3>
              </div>
              <p className="text-gray-600 leading-relaxed text-justify">
                Nitelikli İSG profesyonelleri ile çalışanların ruhsal ve fiziksel açıdan sağlıklı bir şekilde evlerine dönebilmelerini sağlamak ve işletmelere sürdürülebilir güvenlik kültürü kazandırmaktır.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Değerlerimiz</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              İş sağlığı ve güvenliği hizmetlerimizde benimsediğimiz temel değerler
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${value.icon} text-2xl text-orange-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">{value.title}</h3>
                <p className="text-gray-600 text-sm">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Certifications & Accreditations */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Sertifikalar ve Yetki Belgelerimiz</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Kalite ve güvenilirliğimizi tescilleyen ulusal ve uluslararası belgelerimiz
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {certifications.map((cert, index) => (
              <div key={index} className="bg-gradient-to-br from-orange-50 to-white p-8 rounded-lg shadow-lg text-center hover:shadow-xl transition-all hover:-translate-y-1">
                <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-md">
                  <i className={`${cert.icon} text-3xl text-orange-600`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2">{cert.title}</h3>
                <p className="text-gray-600 text-sm">{cert.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-16 bg-gradient-to-r from-orange-600 to-orange-700 text-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold mb-2">{counters.years}+</div>
              <div className="text-orange-200">Yıllık Deneyim</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">{counters.professionals}+</div>
              <div className="text-orange-200">İSG Profesyoneli</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">{counters.customers}+</div>
              <div className="text-orange-200">Mutlu Müşteri</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">{counters.workers.toLocaleString('tr-TR')}+</div>
              <div className="text-orange-200">Korunan Çalışan</div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingButtons />
    </div>
  );
}
